import { render, staticRenderFns } from "./QuestionPicker.vue?vue&type=template&id=8aaf97c2&"
import script from "./QuestionPicker.vue?vue&type=script&lang=js&"
export * from "./QuestionPicker.vue?vue&type=script&lang=js&"
import style0 from "./QuestionPicker.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports